import { ApiPath } from "enums";
import { Get, Post, Patch, Delete } from "utils";

export const getCohortGroups = async () => {
  const res = await Get(ApiPath.CohortGroup);
  return res.data;
};

export const createCohortGroup = async ({ name }) => {
  const res = await Post(ApiPath.CohortGroup, { name });
  return res.data;
};

export const updateCohortGroup = async (cohortGroupId, { name }) => {
  const res = await Patch(`${ApiPath.CohortGroup}/${cohortGroupId}`, { name });
  return res.data;
};

export const deleteCohortGroup = async (cohortGroupId) => {
  const res = await Delete(`${ApiPath.CohortGroup}/${cohortGroupId}`);
  return res.data;
};

export const getCohorts = async () => {
  const res = await Get(ApiPath.Cohort);
  return res.data;
};

export const createCohort = async ({ name, cohortGroupId, description, color }) => {
  const body = { name, color };
  if (cohortGroupId != null) body.cohortGroupId = cohortGroupId;
  if (description) body.description = description;
  const res = await Post(ApiPath.Cohort, body);
  return res.data;
};

export const updateCohort = async (cohortId, patch) => {
  const res = await Patch(`${ApiPath.Cohort}/${cohortId}`, patch);
  return res.data;
};

export const deleteCohort = async (cohortId) => {
  const res = await Delete(`${ApiPath.Cohort}/${cohortId}`);
  return res.data;
};
